if (!customElements.get('slider-swiper-custom')) {
  class SliderSwiperCustom extends HTMLElement {
    connectedCallback() {
      this.classList.add('swiper');

      const itemsDesktop = parseInt(this.dataset.itemsDesktop) || 4;
      const itemsMobile = parseInt(this.dataset.itemsMobile) || 2;
      const showPagination = this.dataset.showPagination === 'true';
      const showArrows = this.dataset.showArrows === 'true';

      const swiperOptions = {
        slidesPerView: itemsMobile,
        spaceBetween: 10,
        loop: true,
        zoom: true,
        breakpoints: {
          1024: {
            slidesPerView: itemsDesktop,
          },
        },
      };

      if (showPagination) {
        swiperOptions.pagination = {
          el: this.querySelector('.swiper-pagination'),
          type: 'fraction',
        };
      }

      if (showArrows) {
        swiperOptions.navigation = {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        };
      }

      new Swiper(this, swiperOptions);
    }
  }

  customElements.define('slider-swiper-custom', SliderSwiperCustom);
}
